import { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import Card from '../ui-elements/Card'

type Props = {
    parameterDefinitions: ObjectStringKeyAnyValue | null
    parameterValues: ObjectStringKeyAnyValue | null
}

// formats a parameter value for display, joining multi-select answers with commas
function formatParameterValue(value: any) {
    if (value === null || value === undefined || value === '') return null
    if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : null
    if (typeof value === 'object') return JSON.stringify(value)
    return `${value}`
}

function ProcessParameters({
    parameterDefinitions,
    parameterValues
}: Props) {
    const { t } = useContext(GlobalContext)

    if (!parameterDefinitions || Object.keys(parameterDefinitions).length === 0) return null

    // parameter ids are param-<timestamp>, so sorting lists them in creation order
    const parameterIds = Object.keys(parameterDefinitions).sort()

    return (
        <Card>
            <div className={`w-full flex flex-col gap-2 py-2`}>
                <p className={`font-bold`}>{t('ProcessPages.ProcessSummary.processParameters')}</p>
                {parameterIds.map((parameterId: string) => {
                    const displayName = parameterDefinitions[parameterId]['DisplayName'] || parameterId
                    const value = formatParameterValue(parameterValues && parameterValues[parameterId])
                    return (
                        <div key={parameterId} className={`w-full flex flex-row gap-4 justify-between text-base`}>
                            <span className={`text-gray-600`}>{displayName}</span>
                            <span className={`text-right ${value === null ? 'text-gray-400 italic' : ''}`}>
                                {value === null ? t('ProcessPages.ProcessSummary.parameterNotSet') : value}
                            </span>
                        </div>
                    )
                })}
            </div>
        </Card>
    )
}

export default ProcessParameters
